// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TxStatusComponent_wrapper__1YnjR","body":"TxStatusComponent_body__n3PQ-"};